import { faCopy } from "@fortawesome/sharp-regular-svg-icons";
import { faCopy as fasCopy } from "@fortawesome/sharp-solid-svg-icons";
import { Button } from "eone-ui/buttons/button";
import { useState } from "react";

export function HelpCopy(props) {
    const [copied, setCopied] = useState(false);

    const getButtonMenuItems = () => {
        const menuItems = [{
            Label: "Copy page as HTML",
            OnClick: copyHtml
        }];

        if (typeof props.GetMarkdown === "function") {
            menuItems.push({
                Label: "Copy page as markdown",
                OnClick: () => copyMarkdown(props.GetMarkdown)
            });
        }

        return menuItems;
    };

    const handleSetCopy = () => {
        setCopied(true);
        setTimeout
        setTimeout(() => setCopied(false), 5000);
    };

    const copyMarkdown = async (getMarkdown) => {
        const markdown = getMarkdown();
        await navigator.clipboard.writeText(markdown);
        handleSetCopy();
    };

    const copyHtml = async () => {
        const body = props.ContainerRef?.current;
        const content = body.innerHTML;
        const htmlBlob = new Blob([content], { type: "text/html" });
        const clipboardItem = new ClipboardItem({
            "text/html": htmlBlob
        });
        await navigator.clipboard.write([clipboardItem]);
        handleSetCopy();
    };

    const menuItems = getButtonMenuItems();
    if (menuItems.length == 0) return null;

    return (
        <Button
            ContainerClass="pd-documentation-page-copy-button"
            MenuItems={getButtonMenuItems()}
            Label={copied ? "Copied" : "Copy"}
            Icon={copied ? fasCopy : faCopy} />
    );
}